import React, { Component } from 'react'

class HeatMapItem extends Component {

  color = () => {

    const { value, family } = this.props

    let lightness = 100

    if (family.match(/\d+\) Metabolism$/)) {
      // Possibly longer to do, but can we change the coloring on only the metabolism bubble?
      // I would like the scale to begin at 0.9 and 1.1 with a range of color extending from
      // 0.5-0.9 (blue) and
      // 1.1-1.6 (red)

      if (value <= 0.9) {
        if (value < 0.5) {
          lightness = 50
        } else {
          // when 0.9 should equal 100
          // when 0.5 should equal 50
          // when 0.7 should equal 75
          lightness = 100 - (Math.round((0.9 - value) / 0.4 * 50))
        }
      } else {
        // the value is greater than 0.9
        if (value > 1.6) {
          lightness = 50
        } else if (value < 1.1) {
          lightness = 100
        } else {
          // when 1.1 should equal 100
          // when 1.6 should equal 50
          // when 1.35 should equal 75
          lightness = 100 - Math.abs((Math.round((1.1 - value) / 0.5 * 50)))

        }
      }

      if (value > 1.1) {
        // red
        return `hsl(0, 100%, ${lightness}%)`
      } else {
        // blue
        return `hsl(240, 100%, ${lightness}%)`
      }

    } else {
      if (Math.abs(value) > 1) {
        // a lightness of 50 means the most vivid of the color
        // a lightness of 100 means white
        // the most vivid is a value of 3.5 or greater
        lightness = 100 - Math.round((Math.min((((Math.abs(value) - 1) / 3.5) * (50 / 36)), 1)) * 50)

      }

      if (value > 0) {
        // red
        return `hsl(0, 100%, ${lightness}%)`
      } else {
        // blue
        return `hsl(240, 100%, ${lightness}%)`
      }
    }
  }

  styles = {
    pill: {
      width: '80px',
      height: '50px',
      backgroundColor: this.color(),
      borderRadius: '40px / 20px',
      display: 'inline-block',
      alignItems: 'center',
      margin: '2px',
      textAlign: 'center',
      fontSize: 'x-small',
      verticalAlign: 'middle',
      borderColor: '#006595',
      position: 'relative',
      border: '1px solid #333',
    },

    container: {
      paddingTop: '12px'
    },

    corner: {
      position: 'absolute',
      height: '10px',
      width: '10px',
      border: '0.5px solid #333',
      backgroundColor: '#fff',
    },

    topLeft: {
      top: '-1px',
      left: '-1px',
      borderRadius: '0 0 100% 0',
      borderWidth: '0 1px 1px 0',
    },

    topRight: {
      top: '-1px',
      left: '70px',
      borderRadius: '0 0 0 100%',
      borderWidth: '0 0 1px 1px',
    },

    bottomLeft: {
      top: '40px',
      left: '-1px',
      borderRadius: '0 100% 0 0',
      borderWidth: '1px 1px 0 0',
    },

    bottomRight: {
      top: '40px',
      left: '70px',
      borderRadius: '100% 0 0 0',
      borderWidth: '1px 0 0 1px',
    },

    dot: {
      backgroundImage: 'radial-gradient(circle at 0 0, rgba(0,0,0,0) 14px, #0 15px)'
    },

// , radial-gradient(circle at 100% 0, rgba(204,0,0,0) 14px, #c00 15px), radial-gradient(circle at 100% 100%, rgba(204,0,0,0) 14px, #c00 15px),radial-gradient(circle at 0 100%, rgba(204,0,0,0) 14px, #c00 15px)

// <div style={ { ...this.styles.corner, ...this.styles.topLeft } }></div>
// <div style={ { ...this.styles.corner, ...this.styles.topRight } }></div>
// <div style={ { ...this.styles.corner, ...this.styles.bottomLeft } }></div>
// <div style={ { ...this.styles.corner, ...this.styles.bottomRight } }></div>

  }


  render() {
    return (
      <div style={ { ...this.styles.pill, ...this.styles.dot } }>

        <div style={ this.styles.container }>
          <div>
            { this.props.name }
          </div>
          <div>
            { this.props.value === 0 ? "0.00" : this.props.value }
          </div>
        </div>

      </div>
    )
  }
}

export default HeatMapItem